import { getInventoryModuleRoutes, InventoryPath } from 'app/inventory/routes';
import { getSaleModuleRoutes, SalePath } from 'app/sale/routes';

const productsMenu = getInventoryModuleRoutes(InventoryPath.ProductList);
const creditSalesMenu = getSaleModuleRoutes(SalePath.CreditSale);

const MENU_OF_INNER_PAGE: Record<string, string> = {
  [getInventoryModuleRoutes(InventoryPath.Product)]: productsMenu,
  [getInventoryModuleRoutes(InventoryPath.Lots)]: productsMenu,
  [getSaleModuleRoutes(SalePath.CreditSalePayment)]: creditSalesMenu,
};

const TRAILING_SLASHES = /\/+$/;

const withoutTrailingSlash = (pathname: string): string => pathname.replace(TRAILING_SLASHES, '') || '/';

export const menuUrlOf = (pathname: string): string => {
  const page = withoutTrailingSlash(pathname);
  return MENU_OF_INNER_PAGE[page] ?? page;
};
